<template>
    <div>
        <van-search @click="openSearch" :clearable="false"
                    placeholder="搜索客户"/>
        <div class="echarts" ref="charts" style="height: 500px;margin-top: 16px"/>
        <van-tabbar route>
            <van-tabbar-item replace to="/work" icon="home-o">工作台</van-tabbar-item>
            <van-tabbar-item replace to="/report" icon="chart-trending-o">报表</van-tabbar-item>
            <van-tabbar-item replace to="/manager" icon="apps-o">管理</van-tabbar-item>
        </van-tabbar>
    </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
    name: "WorkIndex",
    components: {},
    data() {
        return {
            ExternalUserFollowInfo: {},

            option: {
                title: {
                    text: '销售漏斗',
                    // subtext: '销售漏斗',
                    left: 'center',
                    top: 'top',
                },
                series: [
                    {
                        type: 'funnel',
                        left: '10%',
                        top: 40,
                        bottom: 0,
                        width: '80%',
                        min: 0,
                        max: 100,
                        // maxSize: '90%',
                        // minSize: '90%',
                        sort: 'none',
                        gap: 2,
                        // height: "350",
                        emphasis: {
                            label: {
                                fontSize: 14,
                            },
                        },
                        data: [
                            {
                                value: 100,
                                Status: 0,
                                name: '客户',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 80,
                                Status: 50,
                                name: '未知行业',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 70,
                                Status: 100,
                                name: '未跟进',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 60,
                                Status: 200,
                                name: '需求确认',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 50,
                                Status: 300,
                                name: '未演示、试用中',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 400,
                                name: '已演示、试用中',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 500,
                                name: '已演示、未试用',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                            {
                                value: 30,
                                Status: 600,
                                name: '已成交',
                                label: {position: 'inside', formatter: '', color: '#fff'}
                            },
                        ],
                    },
                ],
            },
        }
    },
    created() {
        this.get_data()
    },
    methods: {
        openSearch() {
            this.$router.push({
                path: "/work/search",
                query: {}
            });
        },
        async get_data() {
            this.ExternalUserFollowInfo = await this.$frame.getStdQueryData("ExternalUserFollowInfo")
            this.group_data = this.$utils.groupBy(this.ExternalUserFollowInfo.StdQuery, ["Status"], (cur, data2) => {
                return cur + 1;
            })
            this.group_data_amount = this.$utils.groupBy(this.ExternalUserFollowInfo.StdQuery, ["Status"], (cur, data) => {
                return cur + data.ExpectAmount;
            })

            for (let i = 0; i < this.option.series[0].data.length; i++) {
                let _row = this.option.series[0].data[i]
                let _status = _row.Status.toString()
                this.option.series[0].data[i].label.formatter = _row.name +
                    "\r\n\r\n" + (this.group_data[_status] ? this.group_data[_status] : 0) + "人 , " +
                    (this.group_data_amount[_status] ? this.$utils.toMoney(this.group_data_amount[_status], 2) : 0) + "元"

                this.option.series[0].data[i].value = this.group_data[_status] / this.ExternalUserFollowInfo.StdQuery.length * 100

            }
            // this.option.series[0].data[0].label.formatter = "客户\r\n\r\n" + (this.group_data["0"] ? this.group_data["0"] : 0) + "人 , " + (this.group_data_amount["0"] ? this.$utils.toMoney(this.group_data_amount["0"], 2) : 0) + "元"
            // this.option.series[0].data[1].label.formatter = "需求确认\r\n\r\n" + (this.group_data["10"] ? this.group_data["10"] : 0) + "人 , " + (this.group_data_amount["10"] ? this.$utils.toMoney(this.group_data_amount["10"], 2) : 0) + "元"
            // this.option.series[0].data[2].label.formatter = "有意向\r\n\r\n" + (this.group_data["20"] ? this.group_data["20"] : 0) + "人 , " + (this.group_data_amount["20"] ? this.$utils.toMoney(this.group_data_amount["20"], 2) : 0) + "元"
            // this.option.series[0].data[3].label.formatter = "试用\r\n\r\n" + (this.group_data["30"] ? this.group_data["30"] : 0) + "人 , " + (this.group_data_amount["30"] ? this.$utils.toMoney(this.group_data_amount["30"], 2) : 0) + "元"
            // this.option.series[0].data[4].label.formatter = "已演示\r\n\r\n" + (this.group_data["40"] ? this.group_data["40"] : 0) + "人 , " + (this.group_data_amount["40"] ? this.$utils.toMoney(this.group_data_amount["40"], 2) : 0) + "元"
            // this.option.series[0].data[5].label.formatter = "已成交\r\n\r\n" + (this.group_data["50"] ? this.group_data["50"] : 0) + "人 , " + (this.group_data_amount["50"] ? this.$utils.toMoney(this.group_data_amount["50"], 2) : 0) + "元"

            // this.option.series[0].data[0].value = this.group_data["0"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[1].value = this.group_data["10"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[2].value = this.group_data["20"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[3].value = this.group_data["30"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[4].value = this.group_data["40"] / this.ExternalUserFollowInfo.StdQuery.length * 100
            // this.option.series[0].data[5].value = this.group_data["50"] / this.ExternalUserFollowInfo.StdQuery.length * 100

            if (this.chart == null) {
                this.chart = echarts.init(this.$refs.charts, null, {
                    renderer: 'svg',
                })
                this.chart.on("click", this.clickChart)
            }
            this.chart.setOption(this.option)
        },
        clickChart(params) {
            this.$router.push({
                path: "/work/list",
                query: {
                    Status: params.data.Status
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
